import './styles/main.scss'
import 'slick-carousel/slick/slick.css'
import React, { useState, useEffect, useRef } from 'react';
import About from './components/About'
import Projects from './components/Projects'
import Contacts from './components/Contacts'

function App() {
  const layoutRef = useRef(null);
  const [showUpButton, setShowUpButton] = useState(false);
  const handleScrollForShowUpButton = () => {
    // Check if the user has scrolled past Block3
    const block3OffsetTop = layoutRef.current?.offsetTop || 0;
    setShowUpButton(window.scrollY > block3OffsetTop);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScrollForShowUpButton);
    return () => {
      window.removeEventListener("scroll", handleScrollForShowUpButton);
    };
  }, []);

  return (
    <>
      <About />
      <div className="layout" ref={layoutRef}>
        <Projects />
        <Contacts />
      </div>
      {showUpButton && (
        <button className="btn-up" onClick={scrollToTop}>
          <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"></path>
          </svg>
        </button>
      )}
    </>
  );
}

export default App;